/**
 * What a PO must carry before it is saved as placed (or forecasted), printed,
 * or pushed to NetSuite. A draft is exempt — it is a PO still being filled in
 * and counts nowhere. The server enforces the same list before a NetSuite push.
 * Tariff rates are a reminder, not a requirement (see softMissingPoFields):
 * Danican bills duties with the invoice, so a PO can be placed without them.
 */

import { POLineItem } from "models/InventoryModel";

export type PoStatus = "placed" | "forecasted" | "draft";

export const PO_STATUS_LABELS: Record<PoStatus, string> = {
  placed: "Placed",
  forecasted: "Forecasted",
  draft: "Draft",
};

export function missingPoFields(po: {
  lineItems: POLineItem[];
  containerType?: string | null;
  shipToFcId?: number | null;
}): string[] {
  const missing: string[] = [];
  const lines = po.lineItems.filter(li => li.inventoryId);
  const unpriced = lines.filter(li => li.unitPrice == null || !(li.unitPrice > 0)).length;
  if (lines.length === 0) missing.push("line items");
  else if (unpriced > 0) missing.push(unpriced === lines.length ? "unit prices" : `unit prices (${unpriced} line${unpriced === 1 ? "" : "s"})`);
  if (!po.containerType) missing.push("container type");
  if (po.shipToFcId == null) missing.push("ship-to center");
  return missing;
}

/** Gaps worth flagging that do not block saving or pushing. */
export function softMissingPoFields(po: { lineItems: POLineItem[] }): string[] {
  const lines = po.lineItems.filter(li => li.inventoryId);
  const unrated = lines.filter(li => li.tariffRate == null).length;
  if (lines.length > 0 && unrated > 0) {
    return [unrated === lines.length ? "tariff rate" : `tariff rate (${unrated} line${unrated === 1 ? "" : "s"})`];
  }
  return [];
}
